import { render, staticRenderFns } from "./TabsComponent.vue?vue&type=template&id=d8a49c24&scoped=true&lang=pug"
import script from "./TabsComponent.vue?vue&type=script&lang=ts"
export * from "./TabsComponent.vue?vue&type=script&lang=ts"
import style0 from "./TabsComponent.vue?vue&type=style&index=0&id=d8a49c24&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a49c24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8a49c24')) {
      api.createRecord('d8a49c24', component.options)
    } else {
      api.reload('d8a49c24', component.options)
    }
    module.hot.accept("./TabsComponent.vue?vue&type=template&id=d8a49c24&scoped=true&lang=pug", function () {
      api.rerender('d8a49c24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tabs/TabsComponent/TabsComponent.vue"
export default component.exports